import React from "react";

export const stateWiseExamColumns = (handleExamClick) => [
  {
    dataField: "state_name",
    text: "State Name",
    sort: true,
  },
  {
    dataField: "exam_name",
    text: "Exam Name",
    sort: true,
    formatter: (cell, row) => (
      <span
        className="text-primary cursor-pointer"
        onClick={() => handleExamClick(row)}
        style={{ textDecoration: "underline" }}
      >
        {cell}
      </span>
    ),
  },
  {
    dataField: "state_students",
    text: "Total Students",
    sort: true,
  },
  {
    dataField: "state_avg",
    text: "Average Score",
    sort: true,
    formatter: (cell) => {
    return cell !== null && cell !== undefined
      ? Number(cell).toFixed(1)
      : "-";
  }
  },
  {
    dataField: "state_max",
    text: "Max Score",
    sort: true,

  },
  {
    dataField: "state_min",
    text: "Min Score",
    sort: true,
   
  },
];



export const districtWiseExamColumns = (handleExamClick) => [
  {
    dataField: "state_name",
    text: "State Name",
    sort: true,
  },
  {
    dataField: "district_name",
    text: "District Name",
    sort: true,
  },
  {
    dataField: "exam_name",
    text: "Exam Name",
    sort: true,
    formatter: (cell, row) => (
      <span
        className="text-primary cursor-pointer"
        onClick={() => handleExamClick(row)}
        style={{ textDecoration: "underline" }}
      >
        {cell}
      </span>
    ),
  },
  {
    dataField: "district_students",
    text: "Total Students",
    sort: true,
  },
  {
    dataField: "district_avg",
    text: "Average Score",
    sort: true,
    formatter: (cell) => {
    return cell !== null && cell !== undefined
      ? Number(cell).toFixed(1)
      : "-";
  }
  },
  {
    dataField: "district_max",
    text: "Max Score",
    sort: true,
    
  },
  {
    dataField: "district_min",
    text: "Min Score",
    sort: true,
   
  },
];


export const cityWiseExamColumns = (handleExamClick) => [
  {
    dataField: "state_name",
    text: "State Name",
    sort: true,
  },
  {
    dataField: "district_name",
    text: "District Name",
    sort: true,
  },
  {
    dataField: "city_name",
    text: "City Name",
    sort: true,
  },
  {
    dataField: "exam_name",
    text: "Exam Name",
    sort: true,
    formatter: (cell, row) => (
      <span
        className="text-primary cursor-pointer"
        onClick={() => handleExamClick(row)}
        style={{ textDecoration: "underline" }}
      >
        {cell}
      </span>
    ),
  },
  {
    dataField: "city_students",
    text: "Total Students",
    sort: true,
  },
  {
    dataField: "city_avg",
    text: "Average Score",
    sort: true,
    formatter: (cell) => {
    return cell !== null && cell !== undefined
      ? Number(cell).toFixed(1)
      : "-";
  }
  },
  {
    dataField: "city_max",
    text: "Max Score",
    sort: true,

  },
  {
    dataField: "city_min",
    text: "Min Score",
    sort: true,
 
  },
  {
    dataField: "district_students",
    text: "District Total Students",
    sort: true,
  },
  {
    dataField: "district_avg",
    text: "District Average Score",
    sort: true,
    formatter: (cell) => {
    return cell !== null && cell !== undefined
      ? Number(cell).toFixed(1)
      : "-";
  }
  },
  {
    dataField: "district_max",
    text: "District Max Score",
    sort: true,
   
  },
  {
    dataField: "district_min",
    text: "District Min Score",
    sort: true,
  
  },
  {
    dataField: "state_students",
    text: "State Total Students",
    sort: true,
  },
  {
    dataField: "state_avg",
    text: "State Average Score",
    sort: true,
    formatter: (cell) => {
    return cell !== null && cell !== undefined
      ? Number(cell).toFixed(1)
      : "-";
  }
  },
  {
    dataField: "state_max",
    text: "State Max Score",
    sort: true,
  
  },
  {
    dataField: "state_min",
    text: "State Min Score",
    sort: true,
   
  },
];


export const branchWiseExamColumns = (handleExamClick) => [
  {
    dataField: "state_name",
    text: "State Name",
    sort: true,
  },
  {
    dataField: "district_name",
    text: "District Name",
    sort: true,
  },
  {
    dataField: "city_name",
    text: "City Name",
    sort: true,
  },
  {
    dataField: "branch_name",
    text: "Branch Name",
    sort: true,
  },
  {
    dataField: "exam_name",
    text: "Exam Name",
    sort: true,
    formatter: (cell, row) => (
      <span
        className="text-primary cursor-pointer"
        onClick={() => handleExamClick(row)}
        style={{ textDecoration: "underline" }}
      >
        {cell}
      </span>
    ),
  },
  {
    dataField: "branch_students",
    text: "Total Students",
    sort: true,
  },
  {
    dataField: "branch_avg",
    text: "Average Score",
    sort: true,
    formatter: (cell) => {
    return cell !== null && cell !== undefined
      ? Number(cell).toFixed(1)
      : "-";
  }
  },
  {
    dataField: "branch_max",
    text: "Max Score",
    sort: true,
  },
  {
    dataField: "branch_min",
    text: "Min Score",
    sort: true,
  },
  {
    dataField: "city_students",
    text: "City Total Students",
    sort: true,
  },
  {
    dataField: "city_avg",
    text: "City Average Score",
    sort: true,
    formatter: (cell) => {
    return cell !== null && cell !== undefined
      ? Number(cell).toFixed(1)
      : "-";
  }
  },
  {
    dataField: "city_max",
    text: "City Max Score",
    sort: true,
  },
  {
    dataField: "city_min",
    text: "City Min Score",
    sort: true,
  },
  {
    dataField: "district_students",
    text: "District Total Students",
    sort: true,
  },
  {
    dataField: "district_avg",
    text: "District Average Score",
    sort: true,
    formatter: (cell) => {
    return cell !== null && cell !== undefined
      ? Number(cell).toFixed(1)
      : "-";
  }
  },
  {
    dataField: "district_max",
    text: "District Max Score",
    sort: true,
  },
  {
    dataField: "district_min",
    text: "District Min Score",
    sort: true,
  },
  {
    dataField: "state_students",
    text: "State Total Students",
    sort: true,
  },
  {
    dataField: "state_avg",
    text: "State Average Score",
    sort: true,
    formatter: (cell) => {
    return cell !== null && cell !== undefined
      ? Number(cell).toFixed(1)
      : "-";
  }
  },
  {
    dataField: "state_max",
    text: "State Max Score",
    sort: true,
  },
  {
    dataField: "state_min",
    text: "State Min Score",
    sort: true,
  },
];


export const sectionWiseExamColumns = (handleExamClick) => [
  {
    dataField: "state_name",
    text: "State Name",
    sort: true,
  },
  {
    dataField: "district_name",
    text: "District Name",
    sort: true,
  },
  {
    dataField: "city_name",
    text: "City Name",
    sort: true,
  },
  {
    dataField: "branch_name",
    text: "Branch Name",
    sort: true,
  },
  {
    dataField: "section_name",
    text: "Section Name",
    sort: true,
  },
  {
    dataField: "exam_name",
    text: "Exam Name",
    sort: true,
    formatter: (cell, row) => (
      <span
        className="text-primary cursor-pointer"
        onClick={() => handleExamClick(row)}
        style={{ textDecoration: "underline" }}
      >
        {cell}
      </span>
    ),
  },
  {
    dataField: "section_students",
    text: "Total Students",
    sort: true,
  },
  {
    dataField: "section_avg",
    text: "Average Score",
    sort: true,
    formatter: (cell) => {
    return cell !== null && cell !== undefined
      ? Number(cell).toFixed(1)
      : "-";
  }
  },
  {
    dataField: "section_max",
    text: "Max Score",
    sort: true,
  },
  {
    dataField: "section_min",
    text: "Min Score",
    sort: true,
  },
  {
    dataField: "branch_students",
    text: "Branch Total Students",
    sort: true,
  },
  {
    dataField: "branch_avg",
    text: "Branch Average Score",
    sort: true,
    formatter: (cell) => {
    return cell !== null && cell !== undefined
      ? Number(cell).toFixed(1)
      : "-";
  }
  },
  {
    dataField: "branch_max",
    text: "Branch Max Score",
    sort: true,
  },
  {
    dataField: "branch_min",
    text: "Branch Min Score",
    sort: true,
  },
  {
    dataField: "city_students",
    text: "City Total Students",
    sort: true,
  },
  {
    dataField: "city_avg",
    text: "City Average Score",
    sort: true,
    formatter: (cell) => {
    return cell !== null && cell !== undefined
      ? Number(cell).toFixed(1)
      : "-";
  }
  },
  {
    dataField: "city_max",
    text: "City Max Score",
    sort: true,
  },
  {
    dataField: "city_min",
    text: "City Min Score",
    sort: true,
  },
  {
    dataField: "district_students",
    text: "District Total Students",
    sort: true,
  },
  {
    dataField: "district_avg",
    text: "District Average Score",
    sort: true,
    formatter: (cell) => {
    return cell !== null && cell !== undefined
      ? Number(cell).toFixed(1)
      : "-";
  }
  },
  {
    dataField: "district_max",
    text: "District Max Score",
    sort: true,
  },
  {
    dataField: "district_min",
    text: "District Min Score",
    sort: true,
  },
  {
    dataField: "state_students",
    text: "State Total Students",
    sort: true,
  },
  {
    dataField: "state_avg",
    text: "State Average Score",
    sort: true,
    formatter: (cell) => {
    return cell !== null && cell !== undefined
      ? Number(cell).toFixed(1)
      : "-";
  }
  },
  {
    dataField: "state_max",
    text: "State Max Score",
    sort: true,
  },
  {
    dataField: "state_min",
    text: "State Min Score",
    sort: true,
  },
];